<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Navigation|Migrations title@@navigation-migrations-title">Migrations</h1>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <form [formGroup]="migrationsForm" class="profile-details-form">
        <mat-form-field class="full-width">
          <mat-label [class.text-disabled-color]="inProgress"
                     i18n="Migrations|Select a migration prompt@@migrations-select-migration-prompt">Select a migration
          </mat-label>
          <mat-select [disabled]="inProgress"
                      (selectionChange)="migrationTypeSelected($event)"
                      [compareWith]="migrationTypeCompareWith"
                      [value]="migrationId">
            <mat-option *ngFor="let migrationId of migrations"
                        [value]="migrationId">{{localizeMigrationType(migrationId)}}</mat-option>
          </mat-select>
        </mat-form-field>

        <contest-select *ngIf="competitionId && showContestSelect"
                        class="full-width"
                        [competitionId]="competitionId"
                        (selected)="contestSelected($event)"></contest-select>

        <form-input *ngIf="migrationId"
                    [control]="paramsField"
                    label="Parameters"
                    i18n-label="Migrations|Parameters input label@@migrations-parameters-label"
                    placeholder="Migration params..."
                    i18n-placeholder="Migrations|Parameters input placeholder@@migrations-parameters-placeholder"
                    type="textarea"
                    textAreaHeight="300px"
                    [minLength]="5" [maxLength]="2048"></form-input>
      </form>

      <div class="footer">
        <div class="fill-space"></div>
        <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center"></mat-spinner>
        <div class="fill-space"></div>

        <app-button color="primary"
                    label="Execute"
                    i18n-label="General|Execute action label@@general-execute-action-label"
                    [disabled]="!canExecuteMigration"
                    (clicked)="executeMigration()"></app-button>
      </div>
    </div>
  </div>
</permission-checker>
